import { render, staticRenderFns } from "./producer_cider_view.vue?vue&type=template&id=695d058b&scoped=true"
import script from "./producer_cider_view.vue?vue&type=script&lang=js"
export * from "./producer_cider_view.vue?vue&type=script&lang=js"
import style0 from "./producer_cider_view.vue?vue&type=style&index=0&id=695d058b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695d058b",
  null
  
)

export default component.exports